 var addtocart_selector = '';
 var variant_dropdown_selector = '';
 var qty_selector ='';
 var enable_pvt_app ='no';
 var show_floating_cart = 'yes';
 var show_tbl_after_customer_logged_in = 'no';
 var redirect_cart_page = 'no';
 var hide_price = 'no';
 var hide_price_text = 'Call for price'; 
 var hide_add_to_cart_btn = 'no';
 var hide_variant_dropdowns = 'no';
 var hide_qty_box = 'no';
 var show_out_of_stock = 'yes';
 var currency_code_included = 'yes';
 var default_qty_val = '0';
 var single_atc_status = 'NO';
 var variant_img_size = 'small';
 var enable_filter = 'no';